.minHeight {
    min-height: 440px;
}
.panelPaddingRight {
    padding-right: 20px;
    min-width: 500px;
    margin-bottom: 20px;
}

.panelPaddingLeft {
    padding-left: 20px;
    min-width: 500px;
}

.title {
    font-size: 1.5em;
    font-family: LustTextItalic;
    border-bottom: 1px dashed #d0d5dd;
    color: #243a5c;
    padding-top: 10px;
    padding-bottom: 2px;
    margin-bottom: 28px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.box_container {
    background-color: white;
    border: 1px solid #e9e0be;
    border-radius: 20px;
    padding: 16px;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.box_list_entry {
    :global(.title) {
        font-family: Hanken Grotesk;
        font-weight: 700;
        font-size: 19px;
        color: #102442;
    }

    :global(.text) {
        font-family: Hanken Grotesk;
        font-weight: 400;
        font-size: 13px;
    }
}

.noData {
    font-size: 16px;
    font-weight: 400;
    color: #102442;
}

.sourceLink {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    margin-top: auto;
    align-self: flex-start;
    font-size: 12px;
    font-weight: 500;
    color: #4a90e2;
    background-color: #f0f7ff;
    border: 1px solid #d0e7ff;
    border-radius: 4px;
    text-decoration: none;
    white-space: nowrap;
    transition: all 0.2s ease;

    &:hover {
        background-color: #e0f0ff;
        border-color: #4a90e2;
        color: #2a70c2;
        text-decoration: none;
    }

    &:active {
        background-color: #d0e7ff;
    }

    svg {
        flex-shrink: 0;
    }
}

.dueDiligenceIcon {
    width: 48px !important;
    height: auto !important;
    flex-shrink: 0;
    object-fit: contain;
}

.infoIconWrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: help;
    margin-left: 4px;
}

.infoIcon {
    color: #4a90e2;
    transition: color 0.2s ease;

    &:hover {
        color: #2a70c2;
    }
}

.tooltip {
    position: absolute;
    left: 25px;
    top: -10px;
    width: 400px;
    padding: 12px 16px;
    background-color: #102442;
    color: white;
    font-size: 13px;
    font-family: 'Hanken Grotesk', sans-serif;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease, visibility 0.2s ease;
    pointer-events: none;
    z-index: 1000;

    .infoIconWrapper:hover & {
        opacity: 1;
        visibility: visible;
    }

    &::before {
        content: '';
        position: absolute;
        left: -8px;
        top: 15px;
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-right: 8px solid #102442;
    }
}

// Market Size with Citations styles
.citationNumber {
    font-size: 0.75em;  // Relative to parent text size
    vertical-align: super;
    color: #4a90e2;
    font-weight: 700;
    cursor: pointer;
    transition: color 0.2s ease;
    margin-left: 2px;
    padding: 0 1px;

    &:hover {
        color: #2a70c2;
        text-decoration: underline;
    }
}

.sourcesSection {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e9e0be;
}

.sourcesTitle {
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: #667085;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 10px;
}

.sourcesList {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 6px 20px;  // row-gap, column-gap
    align-items: start;
}

.sourceItem {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 12px;
    line-height: 1.4;
}

.sourceNumber {
    font-size: 0.85em;  // Relative to source item text
    vertical-align: super;
    color: #4a90e2;
    font-weight: 700;
    min-width: 14px;
}

.sourceText {
    color: #4a90e2;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
        color: #2a70c2;
        text-decoration: underline;
    }
}

.sourceTextNoLink {
    color: #667085;
    font-style: italic;
}

// Markdown content (used for Workstream outputs like Competitive Landscape)
.markdownContent {
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 14px;
    color: #102442;
    line-height: 1.6;
    overflow-x: auto;
    padding-bottom: 20px;

    table {
        width: 100%;
        border-collapse: collapse;
        margin: 12px 0;

        th {
            background-color: #243a5c;
            color: white;
            font-weight: 600;
            text-align: left;
            padding: 10px 14px;
            font-size: 13px;
            white-space: nowrap;
        }

        td {
            padding: 8px 14px;
            border-bottom: 1px solid #e9e0be;
            font-size: 13px;
            vertical-align: top;
        }

        tr:nth-child(even) {
            background-color: #f9f8f4;
        }

        tr:hover {
            background-color: #f0efe8;
        }
    }

    p {
        margin: 8px 0;
    }

    strong {
        font-weight: 600;
    }

    ul, ol {
        padding-left: 20px;
        margin: 8px 0;
    }

    li {
        margin-bottom: 4px;
    }
}
